import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgIdleModule } from '@ng-idle/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { MaterialModule } from '../app.material';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ErrorHandlerService } from './core/error-handler.service';
import { provideIdentity } from './identity/providers/identity.provider';
import { Environment } from '../environments/environment';
import { AlertService, SessionService } from './core';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { PilotpayModule } from './pilotpay/pilotpay.module';

const environment: Environment = new Environment();

/**
 * AppModule
 */
@NgModule({
	bootstrap: [AppComponent],
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		CommonModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		LoadingBarHttpClientModule,
		MaterialModule,
		FlexLayoutModule,
		CoreModule,
		NgIdleModule.forRoot(),
		ServiceWorkerModule.register('/ngsw-worker.js', {
			enabled: true
		}),
		PilotpayModule
	],
	providers: [
		{ provide: ErrorHandler, useClass: ErrorHandlerService },
		SessionService,
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		provideIdentity({
			frontendUrl: environment.getConfiguration().frontendIdentityUrl,
			backendUrl: environment.getConfiguration().backendIdentityUrl,
			application: 'pilot-pay',
			debugMode: false,
			refreshTokenOnAuthError: false,
			onAuthorizationError: (error: unknown, injector: Injector) => {
				injector.get(AlertService).authorizationError.next(error);
			}
		})
	]
})

/**
 * AppModule
 */
export class AppModule {}
